// extracted by mini-css-extract-plugin
export default {"emptyText":"EmptyFilteredSection-module__emptyText"};